import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { profileService } from '../../pages/profile/Services/profile.service';

@Injectable({ providedIn: 'root' })
export class imageService {

    private profileService = inject(profileService)

    private userImageSubject = new BehaviorSubject<string | null>(null);
    userImage$ = this.userImageSubject.asObservable();

    setUserImage(url: string | null) {
        this.userImageSubject.next(url);
    }
    loadUserImage(userName: string) {
        // const userName = localStorage.getItem('userName');
        // console.log("userName", userName)
        if (!userName) return;

        this.profileService.GetUserImag(userName).subscribe({
            next: (blob: Blob) => {
                const imageUrl = URL.createObjectURL(blob);
                // console.log("imageUrl", imageUrl)
                this.userImageSubject.next(imageUrl);
            },
            error: () => {
                this.userImageSubject.next(null);
            }
        });
    }

    clear() {
        this.userImageSubject.next(null);
    }
}
